import { fromLonLat, toLonLat } from "ol/proj";

const transformLonLat = ({ coordinates, projection, transformTo = false }) => {
  try {
    const transformFunction = transformTo ? toLonLat : fromLonLat;
    return transformFunction(coordinates, projection);
  } catch (err) {
    console.error("Could not transform coordinates.", err);
    return coordinates;
  }
};

export default transformLonLat;
